import { parsePath } from "./parse-path";
export class NavigatorV22Impl {
    constructor(historyService, logger, 
    /*
     * user interaction sub-path.
     * Example: for url .../de.html/_ui/technical-data the pathName is 'technical-data'
     */
    pathName, 
    /*
     * consumerId that should be used for the subpage (for example of the FA inside the rendered layer).
     * This is used by CMS to render SEO data of the contained FA
     */
    consumerId) {
        this.historyService = historyService;
        this.logger = logger;
        this.pathName = pathName;
        this.consumerId = consumerId;
    }
    getParams() {
        const location = this.historyService.history.location;
        if (!location) {
            this.logger.debug(`getParams: no location found`);
            return undefined;
        }
        const path = parsePath(location.pathname);
        if (!path) {
            this.logger.debug(`getParams: no sub path found in url`);
            return undefined;
        }
        if (this.pathName !== path.name) {
            this.logger.debug(`getParams: id doesn't match the url's path -> ${this.pathName} !== ${path.name} `);
            return undefined;
        }
        this.logger.debug(`getParams ${location.pathname} -> ${path.params.toString()} `);
        return path.params;
    }
    navigate(params) {
        const { historyService } = this;
        const path = createPath(this.pathName, params);
        this.logger.debug(`navigate to ${path}`);
        return {
            replace() {
                historyService.history.replace(path);
            },
            push() {
                historyService.history.push(path);
            },
            createHref() {
                return historyService.history.createHref(path);
            },
        };
    }
    exit() {
        const { historyService } = this;
        return {
            replace() {
                historyService.history.replace("/");
            },
            push() {
                historyService.history.push("/");
            },
            createHref() {
                return historyService.history.createHref("/");
            },
        };
    }
    on(cb) {
        this.listener = cb;
    }
    /**
     * Activate execution of method that was set by the `on` function with params
     */
    notify(pathName, params) {
        if (this.listener) {
            this.listener(pathName === this.pathName ? params : undefined);
        }
    }
    /**
     * Activate execution of method that was set by the `on` function without params
     */
    notifyExit() {
        if (this.listener) {
            this.listener(undefined);
        }
    }
}
export function createPath(name, params) {
    const paramsPath = [];
    params.forEach((value, key) => {
        paramsPath.push(`${encodeURIComponent(key)}/${encodeURIComponent(value)}`);
    });
    const slash = paramsPath.length > 0 ? "/" : "";
    return `/${name}${slash}${paramsPath.join("/")}`;
}
//# sourceMappingURL=navigator.js.map